import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import ModalCloseIcon from "../../../../assets/svg/close-modal.svg";
import info from "../../../../assets/svg/info.svg";
import { toast } from "react-toastify";
import CommonInput from "../../../common/InputField";
import { apiRequest } from "../../../../services/api_services/ApiServices";
import { data } from "autoprefixer";
const profileUrl = process.env.REACT_APP_ADMIN_API_URL;
const ReportAnIssueModal = ({ onSuccess, onCancel }) => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");

  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",

      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "680px",

      overflowY: "auto",
    },
  };
  useEffect(() => {
    issueType();
  }, []);
  const [selectedStatus, setSelectedStatus] = useState("pending");
  const [rejectReason, setRejectReason] = useState("");
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");
  const [title, setTitle] = useState("");
  const [issueTypeList, setIssueTypeList] = useState([]);
  const handleChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const reportIssue = async () => {
    if (!title.trim()) {
      toast.error("Title is required");
      return;
    }
    if (!rejectReason.trim()) {
      toast.error("Description is required");
      return;
    }

    const payload = {
      application: "mai",
      type: selectedStatus,
      title,
      description: rejectReason,
    };

    try {
      const response = await apiRequest({
        method: "POST",
        url: profileUrl + "report_issue",
        data: payload,
      });

      const { success, message, data } = response || {};

      if (!success) {
        toast.error(message || "Failed to report issue");
        return;
      }

      toast.success(message || "Issue reported successfully");
      onSuccess?.(data);
      onCancel?.();
    } catch (error) {
      toast.error("Failed to report issue. Please try again.");
      console.error("Report issue error:", error);
    }
  };

  const issueType = async () => {
    try {
      const response = await apiRequest({
        method: "GET",
        url: profileUrl + "get_issue_type",
      });

      const { success, data, message } = response || {};

      if (!success) {
        toast.error(message || "Failed to fetch issue types");
        return;
      }

      setIssueTypeList(data || []);
    } catch (error) {
      toast.error("Failed to load issue types");
      console.error("Issue type error:", error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl w-[720px] max-w-[95%] shadow-xl pb-3">
        <div className="flex items-center justify-between border-b">
          <h2 className="text-xl font-omny text-gray-900 pl-6 pt-3">
            Report a problem
          </h2>
          <button
            onClick={onCancel}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 text-gray-500 text-sm mr-6"
          >
            ✕
          </button>
        </div>

        <div className="px-6 space-y-3">
          <div>
            <label className="block text-sm font-omny py-3 text-gray-700 mb-2">
              Issue type
            </label>

            <div className="flex flex-wrap gap-3">
              {issueTypeList.map((type) => (
                <label
                  key={type.label}
                  className={`flex items-center gap-2 px-4 py-2 rounded-xl border cursor-pointer transition
              ${
                selectedStatus === type.label
                  ? "border-blue-600 bg-blue-50 text-blue-700"
                  : "border-gray-300 hover:bg-gray-50"
              }`}
                >
                  <input
                    type="radio"
                    name="issue"
                    value={type.label}
                    checked={selectedStatus === type.label}
                    onChange={() => setSelectedStatus(type.label)}
                    className="w-4 h-4 accent-blue-600"
                  />
                  <span className="text-sm font-medium">{type.label}</span>
                </label>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2 font-omny">
              Title
            </label>
            <CommonInput
              className="w-full font-omny text-sm"
              type="input"
              placeholder="Type something here..."
              onChange={(event) => {
                setTitle(event.target.value);
              }}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2 font-omny">
              Explain your problem
            </label>
            <CommonInput
              type="textarea"
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Kindly include as much info as possible..."
              className="w-full h-36 px-4 pt-3 pb-2 pl-0
border border-gray-300 rounded-xl
focus:outline-none focus:ring-2 focus:ring-blue-400
resize-none text-sm font-omny
leading-normal text-left align-top
!block"
            />
          </div>

          <div className="flex items-center justify-end pt-2">
            <button
              onClick={reportIssue}
              className="px-6 py-2 rounded-lg bg-blue-600 text-white font-medium hover:bg-blue-700 transition"
            >
              Send report
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportAnIssueModal;
